import 'jquery-ui/ui/widgets/dialog';
import {PMAPI,PMENUM} from './postmsg';
// import '../lib/Adaptation'
// import '../lib/Adaptation_content'

$.widget("custom.erdsDialog", $.ui.dialog, {
    options: {
        closeText: "关闭",
        classes:{'ui-dialog':'ui-dialog-shadow'},
        resizable: false,
    },
    open: function () {

        this._super();

        if (this.options.defaultMax === true) {
            this._maximizeWindow();
        }
        if (this.options.customSize === true) {
            this._customWindow();
        }
        if(this.options.definedPosition === true) {
            this.uiDialog.css({
                left: this.options.left,
            });
        }
       if(this._browserRedirect()){
           // this.uiDialogTitlebarFull.css({
           //     right: '40px'
           // });
           // this.uiDialogTitlebarClose.css({
           //     right: '20px'
           // })
       }
        if (this.options.closable === false) {
            this.uiDialogTitlebarClose.hide();
            if (this.uiDialogTitlebarFull) {
                this.uiDialogTitlebarFull.css({
                    right: '.3em'
                });
            }
        }

        if(this.options.iszoom){
            this._magnification();
            return
        }
        return this;
    },

    _magnification:function () {
        if(document.getElementsByClassName("ui-dialog-shadow").length == 1){
            this.options.position = {}
            let uiHidget = document.getElementsByClassName("ui-widget-overlay")[0].offsetHeight
            let uiWidth = document.getElementsByClassName("ui-widget-overlay")[0].offsetWidth

            let Dialog = document.getElementsByClassName("ui-dialog-shadow")[0]
            Dialog.style.position = "fixed"
            Dialog.style.top = `${(uiHidget -  this.options.height )/2 < 0 ? 0 :(uiHidget -  this.options.height )/2}px` 
            Dialog.style.left = `${(uiWidth -  this.options.width )/2 < 0 ? 0 :(uiWidth -  this.options.width )/2}px` 
            Dialog.style.margin = 0 
        }else if (this.options.special){ // 投顾审批意见特殊处理
            let uiHidget2 = document.getElementsByClassName("ui-widget-overlay")[1].offsetHeight
            let uiWidth2 = document.getElementsByClassName("ui-widget-overlay")[1].offsetWidth

            let Dialog2 = document.getElementsByClassName("ui-dialog-shadow")[1]
            Dialog2.style.position = "fixed"
            Dialog2.style.top = `${(uiHidget2 -  this.options.height )/2 < 0 ? 0 :(uiHidget2 -  this.options.height )/2}px` 
            Dialog2.style.left = `${(uiWidth2 -  this.options.width )/2 < 0 ? 0 :(uiWidth2 -  this.options.width )/2}px` 
            Dialog2.style.margin = 0 
        } else { // 二级弹框分别处理
            let uiHidget1 = document.getElementsByClassName("ui-widget-overlay")[0].offsetHeight
            let uiWidth1 = document.getElementsByClassName("ui-widget-overlay")[0].offsetWidth
          
            let Dialog1 = document.getElementsByClassName("ui-dialog-shadow")[0]
            Dialog1.style.position = "fixed"
            Dialog1.style.top = `${(uiHidget1 -  this.options.height )/2 < 0 ? 0 :(uiHidget1 -  this.options.height )/2}px` 
            Dialog1.style.left = `${(uiWidth1 -  this.options.width )/2 < 0 ? 0 :(uiWidth1 -  this.options.width )/2}px` 
            Dialog1.style.margin = 0 

            let uiHidget2 = document.getElementsByClassName("ui-widget-overlay")[1].offsetHeight
            let uiWidth2 = document.getElementsByClassName("ui-widget-overlay")[1].offsetWidth

            let Dialog2 = document.getElementsByClassName("ui-dialog-shadow")[1]
            Dialog2.style.position = "fixed"
            Dialog2.style.top = `${(uiHidget2 -  this.options.height )/2 < 0 ? 0 :(uiHidget2 -  this.options.height )/2}px` 
            Dialog2.style.left = `${(uiWidth2 -  this.options.width )/2 < 0 ? 0 :(uiWidth2 -  this.options.width )/2}px` 
            Dialog2.style.margin = 0 
        }
    },


    _browserRedirect() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
            return true
        } else {
            return false
        }
    },
    _customWindow: function () {
        this._removeClass($(this.uiDialog[0]), "ui-dialog-maximize");
        let width = Math.max(400, document.documentElement.clientWidth);
        let height = Math.max(400, document.documentElement.clientHeight - 100);
        this.option('width', width);
        this.option('height', height);
        this.option('position', {my: "center", at: "center", of: window});
        this.fullScreen = false;
        if (this.uiDialogTitlebarFull) {
            this._removeClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-newwin");
            this._addClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-maximize");
            $(this.uiDialogTitlebarFull[0].firstChild).attr('title','全屏');
        }
    },

    _maximizeWindow: function () {
        let width = Math.max(400, document.documentElement.clientWidth);
        let height = Math.max(400, document.documentElement.clientHeight);
        this.options.originHeight = this.options.height;
        this.options.originWidth = this.options.width;
        this.option('width', width);
        this.option('height', height);
        this.option('position', {my: "center top", at: "center top", of: window});
        this.fullScreen = true;
        this.options.resizeMax && this.options.resizeMax();

        if (this.uiDialogTitlebarFull) {
            this._removeClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-maximize");
            this._addClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-newwin");
            $(this.uiDialogTitlebarFull[0].firstChild).attr('title','还原');
            this._addClass($(this.uiDialog[0]), "ui-dialog-maximize");
        }
    },
    _minimizeWindow: function () {
        this._removeClass($(this.uiDialog[0]), "ui-dialog-maximize");
        this.option('width', this.options.originWidth);
        this.option('height', this.options.originHeight);
        this.option('position', {my: "center", at: "center", of: window});
        this.fullScreen = false;
        this.options.resizeMin && this.options.resizeMin();

        if (this.uiDialogTitlebarFull) {
            this._removeClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-newwin");
            this._addClass($(this.uiDialogTitlebarFull[0].firstChild), "icon-maximize");
            $(this.uiDialogTitlebarFull[0].firstChild).attr('title','全屏');
        }
    },
    _createTitlebar: function () {
        this._super();
        if (this.options.maxable === true) {
            this.uiDialogTitlebarFull = $("<button type='button' title='全屏'></button>")
                .button({
                    label: '',
                    icon: "icon-maximize",
                    showLabel: false
                })
                .appendTo(this.uiDialogTitlebar);
            this._addClass(this.uiDialogTitlebarFull, "ui-dialog-titlebar-full");
            this._on(this.uiDialogTitlebarFull, {
                click: function (event) {
                    event.preventDefault();
                    if (this.fullScreen === true) {
                        this._minimizeWindow();
                    } else {
                        this._maximizeWindow();
                    }
                }
            });
            this._on('.ui-dialog-titlebar-close', {
                click: function (event) {
                    event.preventDefault();
                    if(window.top.miniFormVal) {
                        if (window.top.miniFormVal && window.top.miniFormValRealId) {
                            window.top.miniFormValRealId = '';
                            return;
                        }
                    }

                    if(window.top.miniFormVal && window.top.miniFormValRealId == ''){
                        window.top.hideMiniForm[window.top.miniFormValTableId]();
                        delete window.top.miniFormVal[window.top.miniFormValTableId ];
                    }

                }
            });
        }
    },
});






// WEBPACK FOOTER //
// app/lib/jquery-ui.dialog.js